import * as angular from 'angular';

import CoreModule from '../core/core.module';
import GraphsModule from '../graphs/graphs.module';

import BenchmarksBellCurveCtrl from './benchmarksBellCurve.controller';
import BenchmarksConfigService from './benchmarksConfig.service';
import PlanConfigCtrl from './planConfig.controller';

export default angular
  .module('Benchmarks', [CoreModule, GraphsModule, 'aptitude'])
  .controller('BenchmarksBellCurveCtrl', BenchmarksBellCurveCtrl)
  .service('Benchmarks_BenchmarksConfig', BenchmarksConfigService)
  .controller('PlanConfigCtrl', PlanConfigCtrl).name;
